<template>
  <Modal v-model="showRighted" title="操作失败">
    <div class="messageContent">{{message}}</div>
    <div slot="footer">
      <button class="btn btn-s btn-line btn-long roger" type="button" @click="close">知道了</button>
      <button class="btn btn-s btn-default btn-long" type="button" v-if="type == 1" @click="upgrade">了解更多</button>
    </div>
  </Modal>
</template>
<script>
import { Modal } from "iview";
export default {
  data() {
    return {
      type: 1,
      message: null,
      defaultMessage:
        "当前服务级别暂不支持该功能，请拨打 400-051-1302 授权开通。",
      showRighted: false
    };
  },
  components: {
    Modal
  },
  methods: {
    show(message, type) {
      this.message = message || this.defaultMessage;
      this.showRighted = true;
      this.type = type;
    },
    upgrade() {
      window.location.href = "/AiGuanHuai/agh/pop/error";
    },
    close() {
      this.showRighted = false;
    }
  }
};
</script>

<style lang="less" scoped>
.hide {
  display: none;
}

.iveiew-modal-content {
  text-align: center;
  padding-top: 30px;
  font-size: 15px;
  color: #666;
  .ivu-modal-body {
    padding: 16px;
    font-size: 12px;
    line-height: 1.5;
  }
}

.messageContent {
  font-size: 16px;
  background: white url("../assets/img/icon20.svg") 20px 12px no-repeat;
  padding: 26px 20px 26px 120px;
}
</style>